"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManualSubscriptionDtoProviderEnum = void 0;
exports.instanceOfManualSubscriptionDto = instanceOfManualSubscriptionDto;
exports.ManualSubscriptionDtoFromJSON = ManualSubscriptionDtoFromJSON;
exports.ManualSubscriptionDtoFromJSONTyped = ManualSubscriptionDtoFromJSONTyped;
exports.ManualSubscriptionDtoToJSON = ManualSubscriptionDtoToJSON;
exports.ManualSubscriptionDtoToJSONTyped = ManualSubscriptionDtoToJSONTyped;
/**
 * @export
 */
exports.ManualSubscriptionDtoProviderEnum = {
    Manual: 'manual'
};
/**
 * Check if a given object implements the ManualSubscriptionDto interface.
 */
function instanceOfManualSubscriptionDto(value) {
    if (!('plan_code' in value) || value['plan_code'] === undefined)
        return false;
    if (!('provider' in value) || value['provider'] === undefined)
        return false;
    if (!('expires_at' in value) || value['expires_at'] === undefined)
        return false;
    return true;
}
function ManualSubscriptionDtoFromJSON(json) {
    return ManualSubscriptionDtoFromJSONTyped(json, false);
}
function ManualSubscriptionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'plan_code': json['plan_code'],
        'provider': json['provider'],
        'expires_at': json['expires_at'],
    };
}
function ManualSubscriptionDtoToJSON(json) {
    return ManualSubscriptionDtoToJSONTyped(json, false);
}
function ManualSubscriptionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'plan_code': value['plan_code'],
        'provider': value['provider'],
        'expires_at': value['expires_at'],
    };
}
